// extracted by mini-css-extract-plugin
module.exports = {"tab":"Accordion_tab__d3DK7","tab-content":"Accordion_tab-content__2pKrc"};